/* eslint-disable linebreak-style */
/* eslint-disable comma-dangle */
import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <div className="contact section">
      <div className="footer">
        <div className="footer-col follow">
          <div className="text-container">
            <p className="footer-header">
              Follow Our
              <br />
              {' '}
              Development Journey!
            </p>
          </div>
        </div>
        <div className="footer-col">
          <div className="text-container">

            <p className="footer-header">Get Help</p>

            <a href="https://discord.gg/runlegends">
              <p className="footer-text">Contact Us</p>
            </a>
            <a href="https://www.talofagames.com/faq">
              <p className="footer-text">FAQ</p>
            </a>
          </div>
        </div>
        <div className="footer-col">
          <p className="footer-header">About Us</p>
          <a
            href="https://www.linkedin.com/company/talofagames"
            target="_blank"
            rel="noopener noreferrer"
          >
            <p className="footer-text">Careers</p>
          </a>
        </div>
        <div className="footer-col icons">
          <a
            href="https://facebook.com/profile.php?id=100142814893688"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img className="icon" src="./facebookIcon.png" alt="" />
          </a>
          <a
            href="https://twitter.com/PlayRunLegends?lang=en"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img className="icon" src="./twitterIcon.png" alt="" />
          </a>
          <a
            href="https://discord.gg/runlegends"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img className="icon" src="./discordIcon.png" alt="" />
          </a>
        </div>
      </div>
    </div>
  );
}

export default Footer;
